$(function () {

    //departure
    if (searchModel.fromDate) {
        priceGraph.create("#departureGraph", {
            currentDate: searchModel.fromDate,
            originCode: searchModel.originCode,
            originCountryCode: searchModel.originCountryCode,
            destinationCode: searchModel.destinationCode,
            destinationCountryCode: searchModel.destinationCountryCode
        });

        $(document).on("click", "#departureGraph .item .bar span", function (e) {
            e.preventDefault();

            flightSearch.setDepartureDate(moment($(this).attr("data-date")));
            $("#flight-search-form").submit();
        });
    }

    //arrival
    if (searchModel.toDate) {
        priceGraph.create("#returnGraph", {
            currentDate: searchModel.toDate,
            originCode: searchModel.destinationCode,
            originCountryCode: searchModel.destinationCountryCode,
            destinationCode: searchModel.originCode,
            destinationCountryCode: searchModel.originCountryCode
        });

        $("#returnGraph .item .bar span").on("click", function (e) {
            e.preventDefault();

            flightSearch.setArrivalDate(moment($(this).attr("data-date")));
            $("#flight-search-form").submit();
        });
    }
});

var priceGraph = {
    create: function (element, data) {
        fetch(config.searchPriceGraph, {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(data)
        })
            .then(function (response) {
                return response.json()
            })
            .then(function (response) {
                priceGraph.drawGraph(element, data, response);
            });

        return $(element);
    },
    drawGraph: function (element, data, jsonArray) {
        //hide element when json array is not available
        if (jsonArray == null || jsonArray.length == 0)
            $(element).hide();

        // clear all items on init
        $(element).find(".bars .item").remove();
        // clear all months on init
        $(element).find(".months .month-item").remove();

        // get max price from array
        var maxPrice = Math.round(this.getMax(jsonArray, 'dailyPrice').dailyPrice);
        // append max price to graph
        $(element).find(".ya-item.ya100 span").text(maxPrice);
        // append half of max price to graph
        $(element).find(".ya-item.ya50 span").text(Math.round(maxPrice / 2));

        // draw graph bars
        for (var i = 0; i < jsonArray.length; i++) {
            var item = `<div class="item ${moment(data.currentDate).isSame(moment(jsonArray[i].flightDate)) ? 'active' : ''}">
                            <div class="bar" data-toggle="tooltip" data-placement="top" title="${jsonArray[i].dailyPrice} TL">
                                <span style="height:${Math.round((jsonArray[i].dailyPrice / maxPrice) * 100)}%" data-date="${moment(jsonArray[i].flightDate)}"></span>
                            </div>
                            <div class="date">
                                <span>${moment(jsonArray[i].flightDate).format("DD")}</span>
                                <span>${moment(jsonArray[i].flightDate).format("ddd")}</span>
                            </div>
                        </div>`;

            $(element).find(".bars").append($(item));
        }

        // find graph month names
        var monthItems = [];
        var prevMonth = '';
        var prevIndex = 0;
        for (var i = 0; i < jsonArray.length; i++) {
            if ((moment(jsonArray[i].flightDate).month()) != prevMonth) {
                var monthItem = `<div class="month-item">
                            <div class="item-line-left"></div>
                            <div class="item-line-right"></div>
                            <span>${moment(jsonArray[i].flightDate).format('MMMM')}</span>
                        </div>`;

                monthItems.push({html: monthItem, width: (100 / jsonArray.length)});
                prevIndex++;
            } else {
                monthItems[prevIndex - 1].width += (100 / jsonArray.length);
            }

            prevMonth = moment(jsonArray[i].flightDate).month();
        }

        // draw graph months
        for (var i = 0; i < monthItems.length; i++) {
            var item = $(monthItems[i].html).css("max-width", `${monthItems[i].width}%`);
            $(element).find(".months").append(item);
        }

        var firstDate = $(element).find(".bars .item:first span").attr("data-date");
        $(element).find(".left-arrow").attr("data-date", moment(new Date(firstDate)).add(-16, 'days').format());
        $(element).find(".left-arrow").on("click", function (e) {
            e.preventDefault();

            var options = {
                currentDate: $(this).attr("data-date"),
                originCode: data.originCode,
                originCountryCode: data.originCountryCode,
                destinationCode: data.destinationCode,
                destinationCountryCode: data.destinationCountryCode
            };

            priceGraph.create(element, options);
        });

        var lastDate = $(element).find(".bars .item:last span").attr("data-date");
        $(element).find(".right-arrow").attr("data-date", moment(new Date(lastDate)).add(16, 'days').format());
        $(element).find(".right-arrow").on("click", function (e) {
            e.preventDefault();

            var options = {
                currentDate: $(this).attr("data-date"),
                originCode: data.originCode,
                originCountryCode: data.originCountryCode,
                destinationCode: data.destinationCode,
                destinationCountryCode: data.destinationCountryCode
            };

            priceGraph.create(element, options);
        });
    },
    getMax: function (array, propName) {
        var max = 0;
        var maxItem = {};

        for (var i = 0; i < array.length; i++) {
            var item = array[i];
            if (item[propName] > max) {
                max = item[propName];
                maxItem = item;
            }
        }

        return maxItem;
    }
}
